import PropTypes from "prop-types"

import { cn } from "styles/utils"

export const StaticSectionTitle = ({ className, ...props }) => (
  <h2
    className={cn(
      "text-20 tablet:text-left my-20 text-center font-normal text-black",
      className
    )}
    {...props}
  />
)

StaticSectionTitle.propTypes = {
  className: PropTypes.string,
}

export const Section = ({ className, ...props }) => (
  <div
    className={cn("tablet:pb-48 tablet:pt-48 bg-white pt-32", className)}
    {...props}
  />
)

Section.propTypes = {
  className: PropTypes.string,
}

export const SectionTitle = ({ className, ...props }) => (
  <h2
    className={cn(
      "text-20 leading-28 text-center font-medium uppercase",
      className
    )}
    {...props}
  />
)

SectionTitle.propTypes = {
  className: PropTypes.string,
}

export const Text = ({ className, ...props }) => (
  <p
    className={cn("text-16 leading-22 font-light tracking-tight", className)}
    {...props}
  />
)

Text.propTypes = {
  className: PropTypes.string,
}

export const Footnote = (props) => (
  <div
    className="my-10 bg-[rgba(37,104,178,0.05)] py-8 text-center"
    {...props}
  />
)

export const FootnoteText = (props) => (
  <p
    className="text-12 leading-14 max-w-240 mx-auto font-bold tracking-tight"
    {...props}
  />
)
